<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-31 02:03:27
-->
<template>
  <div class="orderItem" @click="goDetail">
    <div class="inner">
      <div class="top flex">
        <div class="left">
          {{ (info.bizName && info.bizName.split("")[0]) || "-" }}
        </div>
        <div class="right">
          <div class="bizName">{{ `${info.bizName || "--"}` }}</div>
          <div class="sgInfo">
            <span class="goodstype">{{ info.goodsType || "--" }}</span>
            <span class="goodsWeight">{{ info.goodsWeight || 0 }}吨</span>
          </div>
        </div>
        <div class="tips">
          <p v-if="info.state == '1'" :class="['tipSpan', `tipSpan1`]">
            <span>接单中</span>
          </p>
          <p
            v-if="info.state == '3' || info.state == '4'"
            :class="['tipSpan', `tipSpan3`]"
          >
            <span>已接单</span>
          </p>
          <p v-if="info.state == '5'" :class="['tipSpan', `tipSpan5`]">
            <span>已打卡</span>
          </p>
          <p v-if="info.state == '6'" :class="['tipSpan', `tipSpan4`]">
            <span>已完单</span>
          </p>
        </div>
        <div class="bottms">
          接单人：<span style="color: #333">{{
            info.acceptPerson || "--"
          }}</span>
        </div>
      </div>
      <div class="middle flex">
        <div class="left">
          <div>
            <p class="tip">始发地：</p>
            <p class="place">{{ info.originPlace || "--" }}</p>
          </div>
          <div>
            <p class="tip">目的地：</p>
            <p class="place">{{ info.destinationPlace || "--" }}</p>
          </div>
        </div>
        <div class="right">
          <img
            class="rightIcon"
            src="../../../../assets/workOrder/rightIcon.png"
          />
          <p class="rightText">已中标</p>
        </div>
      </div>
      <div class="info">
        <p><span>预装时间：</span>{{ info.estimateTime || "--" }}</p>
        <!-- <div
          class="btn1"
          v-if="info.state == 1 || info.state == 2"
          @click.stop="changeStatus('1')"
        >
          接单
        </div> -->
        <div
          class="btn2"
          v-if="info.state == 3 || info.state == 4"
          @click.stop="changeStatus('2')"
        >
          打卡
        </div>
        <div
          class="btn3"
          v-if="(info.state == 3 || info.state == 4) && info.back == 0"
          @click.stop="changeStatus('3')"
        >
          退回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail } from "@/utils/network/interface";
export default {
  name: "orderItem",
  components: {},
  props: {
    type: String,
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    changeStatus(methods) {
      this.$emit("action", this.info, methods);
    },
    goDetail() {
      //  1,待接单,2 退回状态  3 已接单  4 已指派  5 已打卡 6 已完单
      console.log(this.type, "typetype");
      if ([1, 2].indexOf(this.info.state) > -1) return;
      if (this.type == "workList1") return;
      this.$router.push({
        path: "/workOrder/order/detail",
        query: { info: JSON.stringify(this.info) },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.orderItem {
  width: 96%;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 10px;
  padding: 0 15px;
  .inner {
    padding: 15px 0;
    .top {
      margin-bottom: 10px;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 10px;
      position: relative;
      .left {
        flex: 0 0 40px;
        height: 40px;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        background: #44b1f9;
        border-radius: 6px;
        color: #fff;
        margin-right: 10px;
      }
      .bizName {
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        padding: 2px 0;
        line-height: 16px;
        margin-bottom: 2px;
      }
      .sgInfo {
        span {
          display: inline-block;
          padding: 2px 5px;
          font-size: 12px;
          line-height: 1.1;
        }
        .goodstype {
          margin-right: 10px;
          background: rgba(31, 181, 74, 0.15);
          color: #1fb54a;
        }
        .goodsWeight {
          margin-right: 10px;
          background: rgba(255, 0, 0, 0.15);
          color: #ff0000;
        }
      }
      .tips {
        position: absolute;
        top: 0;
        right: 0;
        .tipSpan {
          display: block;
          text-align: center;
          width: 60px;
          height: 20px;
          color: #fff;
          position: relative;
          &::before {
            position: absolute;
            content: "";
            display: block;
            width: 100%;
            height: 100%;
            transform: skew(-15deg, 0);
            background-color: #333;
            top: 0;
            left: 0;
            border-radius: 3px;
          }
          span {
            display: block;
            width: 100%;
            height: 100%;
            line-height: 20px;
            position: relative;
            font-size: 12px;
          }
          &1 {
            &::before {
              background: linear-gradient(-87deg, #fcbe73 0%, #fc9642 100%);
            }
          }
          &3 {
            &::before {
              background: linear-gradient(-87deg, #fcbe73 0%, #fc9642 100%);
            }
          }
          &5 {
            &::before {
              background: linear-gradient(-87deg, #52c5ff 0%, #508aed 100%);
            }
          }
          &4 {
            &::before {
              background: linear-gradient(-87deg, #61cda9 0%, #29b27a 100%);
            }
          }
        }
      }
      .bottms {
        position: absolute;
        right: 0;
        top: 30px;
        font-size: 12px;
        color: #999;
      }
    }
    .middle {
      vertical-align: middle;
      border-radius: 5px;
      color: #333;
      margin-bottom: 15px;
      align-items: center;
      justify-content: space-between;
      .left {
        background: url("../../../../assets/workOrder/itemLeft.png") left center
          no-repeat;
        background-size: 8px 44px;
        min-height: 44px;
        padding-left: 15px;
        > div:first-child {
          margin-bottom: 6px;
        }
        .tip,
        .place {
          display: inline-block;
          vertical-align: middle;
          font-size: 13px;
          line-height: 28px;
        }
        .tip {
          color: #999;
          margin-right: 5px;
        }
        .place {
          font-weight: bold;
          color: #000;
        }
      }
      .right {
        flex: 0 0 40px;
        text-align: center;
        .rightIcon {
          display: block;
          width: 32px;
          height: 32px;
          margin: 0 auto 6px;
        }
        .rightText {
          font-size: 13px;
          color: #44b1f9;
          font-weight: 500;
        }
      }
    }
    .info {
      border-top: 1px solid #eeeeee;
      padding-top: 10px;
      p {
        font-size: 13px;
        line-height: 2;
        color: #333;
        span {
          color: #999;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .btn1 {
        text-align: center;
        padding: 0 15px;
        height: 26px;
        background: #44b1f9;
        font-size: 14px;
        line-height: 26px;
        color: white;
        border-radius: 5px;
        float: right;
        margin-top: -23px;
      }
      .btn2 {
        text-align: center;
        padding: 0 15px;
        height: 26px;
        background: rgba(68, 177, 249, 0.15);
        border: 1px solid #44b1f9;
        font-size: 14px;
        line-height: 26px;
        color: #44b1f9;
        border-radius: 5px;
        float: right;
        margin-top: -23px;
      }
      .btn3 {
        text-align: center;
        padding: 0 15px;
        height: 26px;
        background: #c1c1c1;
        border-radius: 5px;
        font-size: 14px;
        line-height: 26px;
        color: white;
        float: right;
        margin-top: -23px;
        margin-right: 10px;
      }
    }
  }
}
</style>